import {AUTH_INIT_MODELS, RESERVATION_NOT_FOUND_BEHAVIOR} from '@chekin/core';
import {useHousing} from './useHousing';
import {useChekinSDK} from 'context/ChekinSDK';
import {useModalControls} from '@chekin/guestapp-ui-kit';

function useReservationNotFound() {
  const {modelName} = useChekinSDK();
  const {housing} = useHousing();
  const {
    isOpen: isNotFoundModalOpen,
    openModal: openNotFoundModal,
    closeModal: closeNotFoundModal,
  } = useModalControls();

  const canCreate =
    modelName === AUTH_INIT_MODELS.housing &&
    housing?.reservation_not_found_behavior === RESERVATION_NOT_FOUND_BEHAVIOR.create;

  return {
    canCreate,
    isNotFoundModalOpen,
    openNotFoundModal,
    closeNotFoundModal,
  };
}

export {useReservationNotFound};
